import { MeditationRetreatsByYear } from "@/components/MeditationRetreats";
import { StatisticsTypeLabel, StatisticsTypeLinkURL } from "@/constants";
import { useGetStatisticsData } from "@/hooks/query-hooks/useMeditationRetreats";
import { cn } from "@/libs/cn";
import { Button, Card, Divider, Statistic } from "antd";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router";
import { AnimatedComponent, PageTitle } from "../common";

export function Dashboard() {
	const { data, isLoading } = useGetStatisticsData();

	return (
		<AnimatedComponent className="space-y-10">
			<Helmet>
				<title> Dashboard</title>
			</Helmet>
			<div>
				<PageTitle>Today's Update</PageTitle>
				<Divider />
				<div className="grid grid-cols-3 gap-4">
					{data &&
						data?.map((item) => (
							<Link
								to={StatisticsTypeLinkURL[item.type]}
								key={JSON.stringify(item)}
							>
								<Card
									key={JSON.stringify(item)}
									variant="outlined"
									rootClassName="!border-f80"
									loading={isLoading}
								>
									<Statistic
										title={StatisticsTypeLabel[item.type]}
										value={item.count}
										suffix={" requests"}
										rootClassName={cn(
											"text-center !p-5 [&>.ant-statistic-title]:!text-base [&>.ant-statistic-title]:!text-gray-800 [&>.ant-statistic-title]:!mb-2 [&>.ant-statistic-content]:!text-sm [&>.ant-statistic-content]:!text-blue-500 [&>.ant-statistic-content]:!font-poppins ",
										)}
									/>
								</Card>
							</Link>
						))}
				</div>
			</div>

			<MeditationRetreatsByYear
				Component={() => (
					<Link to={"/meditation-retreats"}>
						<Button
							type="primary"
							shape="round"
							size="large"
							className="!px-6 bg-primary-gradient"
						>
							View
						</Button>
					</Link>
				)}
				isInDashboard
			/>
		</AnimatedComponent>
	);
}
